import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import Post from "../ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem, Typography } from '@mui/material';
import DokKokas from './DokKokas'
export default function Domisili(){

    
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip,query]);

    async function newKontrak(e){
        history("/create-kontrak",{state:{stuff:"new"}})
    }

    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }

                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");
    const [openDokKokas,setOpenDokKokas]=useState(false)

    const previewPDF = async (post) => {
        console.log(post)
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id

        if(post.kokasDomisili){
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${post.kokasDomisili}`, {
                responseType: 'blob' // Tell axios to get the response as a blob
            })
            .then((response) => {
              const contentType = response.headers['content-type'];
              console.log(response);
              console.log(response.headers)
              console.log(contentType)
              if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                const blob = new Blob([response.data], { type: contentType });
                const url = URL.createObjectURL(blob);
                window.open(url);
                setPreviewVisibility(true)
                setLoadVisibility(false)
                setFileURL(url)
            } else {
                // For other file types, download the file
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                document.body.appendChild(link);
                link.click();

            }
            })
            .catch((error) => {
                console.log('Error fetching the file:', error);
            });
        }else{

            console.log("belum ada Domisili Kokas")
            setLoadVisibility(false)
            setOpenDokKokas(true)


        }    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("KlienNama");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const closeOpenDokKokas = () =>{
        setOpenDokKokas(false)
    }

    return <Grid container>
                <Dialog open={openDokKokas} onClose={closeOpenDokKokas}>
                    <DokKokas currPreview={currPreview}></DokKokas>
                </Dialog>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => editPI()}>
                        <EditIcon></EditIcon>
                    </Button>
                    <Button onClick={() => extend()}>
                        Extend
                    </Button>
                    </DialogActions>
                </Dialog>
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                    <Header judul="Domisili Kokas" isi="Khusus Domisili Kokas"></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}></Grid>
                    <Grid sx={{ pl:15}}>
                            <Typography><b>Cek Domisili Berdasarkan Kontraks</b></Typography>
                        
                            <Grid container>
                                <Grid item xs={2}>
                                    <Select  fullWidth value={searchThis} onChange={event => setsearchThis(event.target.value)}><MenuItem value="KlienNama">Klien</MenuItem><MenuItem value="kontrakAmount">Kode Kontrak</MenuItem><MenuItem value="CompanyName">Company</MenuItem></Select>
                                </Grid>
                                <TextField value={query} onChange={event => handleSearch(event)}></TextField>
                            </Grid>
                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Klien
                                                </TableCell>
                                                <TableCell>
                                                    Company
                                                </TableCell>
                                                <TableCell>
                                                    Tipe Kontrak
                                                </TableCell>
                                                <TableCell>
                                                    Nomor Kontrak
                                                </TableCell>
                                                <TableCell>
                                                    Tanggal Berakhir
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover sx={{ '&:hover': {
                backgroundColor: '#cceffb !important',
            },backgroundColor: post.statNotify === 'No' ? 'red' : 'white'}}>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.KlienNama}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.CompanyName}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.TipeKontrak}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.kontrakAmount}</p>
                                                    </TableCell>
                                                    <TableCell>
                                                    <p>{new Date(post.TanggalBerakhir).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                                    </TableCell>
                                                    
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };